<template>
	<ProcessCreatePage>
		<Header :title="$t('new_order_documentation_type').toString()">
			{{ $t('new_order_documentation_type_pick') }}
		</Header>

		<div class="main">
			<div class="grid md:grid-cols-3 gap-8">
				<BaseRadioForm ref="BaseRadioForm.Type" :required="true" label="Art" :options="orderTypeOptions" v-model="orderType" />
			</div>
		</div>

		<Footer
			@backButtonClick="$emit('previous', $event)"
			@continueButtonClick="continueButtonClick(false)"
			@skipButtonClick="continueButtonClick(true)"
			:is-skippable="false"
			:is-back-button="true"
		/>
	</ProcessCreatePage>
</template>

<script>
import Header from '@/components/damagecases/Header';
import Footer from '@/components/damagecases/Footer';
import BaseRadioForm from '@/components/forms/inputs/BaseRadioForm';
import BaseInput from '@/components/forms/inputs/BaseInput';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';
import Validate from '@/mixins/Validate';
import OrderDocumentationTypesRepository from '@/api/repositories/OrderDocumentationTypesRepository';

export default {
	name: 'ProcessCreateOrderDocumentationOrderType',
	components: { ProcessCreatePage, BaseRadioForm, Footer, Header },
	mixins: [Validate],
	data() {
		return {
			orderType: null,
			orderTypeOptions: [],
			orderDocumentationTypes: [],
		};
	},
	mounted() {
		this.fetchOrderDocTypes();
	},
	methods: {
		fetchOrderDocTypes() {
			new OrderDocumentationTypesRepository().fetchAllOrderDocumentationTypes().then(response => {
				this.orderDocumentationTypes = [...response.data.adminTypes, ...response.data.ownTypes].sort((a, b) => a.name.localeCompare(b.name));
				this.orderTypeOptions = this.orderDocumentationTypes.map(option => {
					option.value = option.id;
					option.display = option.name;
					return option;
				});
			});
		},
		continueButtonClick: function(isSkip) {
			if (isSkip) {
				this.$emit('next');
			} else if (this.validate()) {
				this.$store.commit('setProcessCreateOrderDocumentationOrderType', this.orderType);
				this.$emit('next');
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('new_order_documentation_type_pick').toString(), 'warning');
			}
		},
	},
};
</script>

<style scoped></style>
